import { render, staticRenderFns } from "./attachmentUpload.vue?vue&type=template&id=f700d174&scoped=true"
import script from "./attachmentUpload.vue?vue&type=script&lang=js"
export * from "./attachmentUpload.vue?vue&type=script&lang=js"
import style0 from "./attachmentUpload.vue?vue&type=style&index=0&id=f700d174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f700d174",
  null
  
)

export default component.exports